export default "__VITE_ASSET__BzMdzQl$__"